import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import Chart from '../Chart';
import './styles.css';

class EconomicChart extends Component {
	formatData( value ) {
		return `${numeral(value).format('0.0a')}`;
	}
	render() {
		const { data, options } = this.props;
		return (
			<div className="economic-chart">
				<Chart
					option={{
						grid: {
							width: '40%',
							left: '10%'
						},
						color: [
							'#50e3c2',
							'#f8e71c',
							'#7ed321',
							'#4a90e2',
							'#d0021b',
							'#bd10e0',
							'#efb43f'
						],
						textStyle: {
							color: 'white'
						},

						legend: {
							type: 'scroll',
							orient: 'vertical',
							left: '60%',
							data: data.map(row => row.label),
							textStyle: {
								color: 'white'
							}
						},

						xAxis: {
							type: 'category',
							data: ['YEAR 1', 'YEAR 2', 'YEAR 3'],
							offset: 8,
							boundaryGap: false
						},

						yAxis: {
							type: 'value',
							axisLabel: {
								formatter : (value) => this.formatData(value),
								padding: [3, 5]
							},
							splitLine: {
								show: false
							}
						},

						series: data.map(row => ({
							name: row.label,
							type: 'line',
							data: row.values.map(ele => ele.value),
							label: {
								fontWeight: 'lighter',
								fontSize: 9,
								emphasis: {
									formatter : (params) => this.formatData(params.value),
									show: true,
									position: 'top'
								}
							}
						})),
						...options
					}}
				/>
			</div>
		);
	}
}

EconomicChart.propTypes = {
	options: PropTypes.object,
	data: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string,
			values: PropTypes.arrayOf(PropTypes.object)
		})
	)
};

export default EconomicChart;
